import Swal from 'sweetalert2';
import dayjs from '../core/dayjs';

export default {
  methods: {
    showConfirmationAlert (data, destiny = null) {
      const planName = data.plan_name;
      const expiresAt = this.formatDate(data.expires_at);
      const nextInvoicePrice = this.formatPrice(data.price);

      Swal.fire({
          icon: 'success',
          iconColor: '#2CEBA9',
          html:   `<h2>Upgrade de plano feito com sucesso!</h2>`
                + `<div class="info-container mt-4 mb-3">`
                +   `<span class="info-title">Você migrou para o plano:</span>`
                +   `<span class="info-value mb-2">${planName}</span>`
                +   `<span class="info-title">Data de vencimento:</span>`
                +   `<span class="info-value mb-2">${expiresAt || 'Sem data de vencimento'}</span>`
                +   `<span class="info-title">Valor da próxima mensalidade:</span>`
                +   `<span class="info-value">${nextInvoicePrice}</span>`
                + `</div>`,
          buttonsStyling: false,
          allowOutsideClick: false,
          confirmButtonText: 'Concluir',
          customClass: {
            container:'container-upgrade-plan-swal',
            confirmButton: 'salesflow-btn salesflow-btn-secondary'
          }
      }).then(() => {
        if (destiny) {
          window.location = '/billing';

          return;
        }

        window.location.reload();
      });
    },

    formatDate (date) {
      if (!date) {
        return null;
      }

      const dayJsDate = dayjs(date, 'YYYY/MM/DD');

      return dayJsDate.format('DD/MM/YYYY');
    },

    formatPrice (price) {
      if (!price) {
        return null;
      }

      return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL'
      }).format(price);
    },
  },
};

